module.exports = __webpack_public_path__ + "static/images/ui/ui-bg_flat_50_5c5c5c_40x100.png";